import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import TypeList from './TypeList';
import SkeletonContainer from '../Layout/SkeletonContainer';
import Search from '../Layout/Search';

class Types extends Component {

    render(){
        const { getTypes, typesMeta } = this.props;
        return (
            <SkeletonContainer title="TYPES">
                <Search endpoint="types" width="40%" getData={getTypes} meta={typesMeta}/>
                <TypeList />
            </SkeletonContainer>
        );
    }
}

const mapStateToProps = (state) => ({
    typesMeta: state.typeStore.typesMeta,
});

export default connect(mapStateToProps,Actions.types)(Types);


// WEBPACK FOOTER //
// ./src/Components/App/Types/index.js